module.exports = __webpack_public_path__ + "img/29.5bdd8f6c.jpg";